// src/redux/actions/ComSizeRecruiterActions.js

import axios from '../../API/axios';
import {
    FETCH_WORKLOCATION_TYPE_REC_REQUEST,
    FETCH_WORKLOCATION_TYPE_REC_SUCCESS,
    FETCH_WORKLOCATION_TYPE_REC_FAILURE,
    SET_WORKLOCATION_COMPANY_REC_TYPE, 
} from '../types';

// Action to fetch company size data
export const fetchWorkLocationTypeData = () => async (dispatch) => {
    dispatch({ type: FETCH_WORKLOCATION_TYPE_REC_REQUEST });
    try {
        const response = await axios.get('MasterDDL/GetWorkLocationTypesDDL');
        // console.log('WorkLocationTypeResponse:', response);

        // Map response data to { value, label } format
        const workLocationOptions = response.data.responseData.map((val) => ({
            value: val.id,
            label: val.name, 
        }));

        dispatch({
            type: FETCH_WORKLOCATION_TYPE_REC_SUCCESS,
            payload: workLocationOptions,
        });
    } catch (error) {
        dispatch({
            type: FETCH_WORKLOCATION_TYPE_REC_FAILURE,
            payload: error.message,
        });
    }
};

// Action to select a specific company size
export const selectWorkLocation = (sizeId) => ({
    type: SET_WORKLOCATION_COMPANY_REC_TYPE,
    payload: sizeId,
});